import React from 'react'
import PropTypes from 'prop-types'
import { Calendar, Checkbox, Time } from 'components/forms'
import { PICKUP_LABELS } from 'constants/shipments'

export const Checkin = React.memo(
  ({
    checkinDate,
    checkinTime,
    checkinWarning,
    label: checkinLabel,
    nextStatus,
    onChangeDate,
    onChangeTime,
  }) => {
    let label = `${checkinLabel} at`
    if (PICKUP_LABELS.includes(nextStatus)) label = 'Checked in at'

    return (
      <div className='row'>
        <div className='flex items-end'>
          <div className='col-xs-6 col-lg-6'>
            <Calendar
              name='checkinDate'
              value={checkinDate}
              size='small'
              label={label}
              placeholder='Date'
              date={checkinDate}
              options={{ enableTime: false, dateFormat: 'm/d/Y' }}
              dateTimeChangeToState={onChangeDate}
              required
              dataTest='status-update-dialog-checkin-date'
            />
          </div>
          <div className='col-xs-3 col-lg-3'>
            <Time
              id='checkinTime'
              name='checkinTime'
              value={checkinTime}
              onChange={onChangeTime}
              required
              dataTest='status-update-dialog-checkin-time'
            />
          </div>
        </div>
        {checkinWarning && (
          <div className='col-xs-12 col-lg-12'>
            <p className='text-warning'>{checkinWarning}</p>
          </div>
        )}
      </div>
    )
  }
)

export const Osd = React.memo(({ onChangeOsd, osd }) => (
  <>
    <Checkbox
      label='OS&D'
      name='Osd'
      checked={osd}
      value={osd}
      onChange={onChangeOsd}
      dataTest='status-update-osd-checkbox'
    />
  </>
))

Checkin.propTypes = {
  label: PropTypes.string.isRequired,
  nextStatus: PropTypes.string.isRequired,
  checkinDate: PropTypes.string,
  checkinTime: PropTypes.string,
  checkinWarning: PropTypes.string,
  onChangeTime: PropTypes.func.isRequired,
  onChangeDate: PropTypes.func.isRequired,
}
Checkin.defaultProps = {
  checkinDate: '',
  checkinTime: '',
  checkinWarning: '',
}

Osd.propTypes = {
  osd: PropTypes.bool.isRequired,
  onChangeOsd: PropTypes.func.isRequired,
}
